import { dtoCtor } from '../helper';
import { AppUser } from './appUser';

class Identity extends AppUser {
  dtoName?: string;

  constructor(props?: Omit<Identity, 'dtoName'>) {
    super(props);
    dtoCtor(this, 'Identity', props);
  }

  token?: string;
  new?: boolean;
}

export { Identity };
